<atlas-tab-header
  [labels]="tabLabels"
  (selected)="setSelectedTab($event)"
></atlas-tab-header>
<ng-content></ng-content>
